import { call, put, takeEvery } from "redux-saga/effects";

import { getNotificationsListQuery, injectNotificationDocument, normalizeReduxNotification } from "./utils";
import { rsf } from "../../init/firebase";
import { initialNotificationsFetch, setInitialNotificationsList } from "./reducer";

function* getRequestsNotificationsList(data: any): any {
  const { query } = data.payload;

  try {
    const snapshots = yield call(rsf.firestore.getCollection, getNotificationsListQuery(query));

    const modifiedNotifications = yield injectNotificationDocument(snapshots.docs);
    const { listIds, listMap } = normalizeReduxNotification(modifiedNotifications);

    yield put(setInitialNotificationsList({ listIds, listMap, error: null }));
  } catch (ex: any) {
    yield put(setInitialNotificationsList({ listIds: [], listMap: {}, error: ex.message }));
    console.log(ex.message);
  }
}

export function* watchFetchNotifications() {
  yield takeEvery(initialNotificationsFetch.toString(), getRequestsNotificationsList);
}
